"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagerItem = void 0;
var react_1 = __importDefault(require("react"));
var PagerItem = function (props) {
    var classes = ["c-pager__item"];
    if (props.selected) {
        classes.push("+selected");
    }
    if (props.type) {
        classes.push("+" + props.type);
    }
    if (props.disabled) {
        classes.push("+disabled");
    }
    var handleClick = function () {
        if (props.disabled || !props.onClick) {
            return;
        }
        return props.onClick();
    };
    return (react_1.default.createElement("li", { className: classes.join(" "), onClick: handleClick }, props.children));
};
exports.PagerItem = PagerItem;
//# sourceMappingURL=PagerItem.js.map